import React, { useState } from "react";
import {
  Grid, Paper, Typography, Box, Stack, Switch, FormControlLabel, Button, Divider, Chip
} from "@mui/material";

function Card({ title, subtitle, children }) {
  return (
    <Paper elevation={0} sx={{ p: 2, borderRadius: 2, border: "1px solid var(--border)", bgcolor: "var(--branco)" }}>
      <Typography sx={{ fontWeight: 900, color: "var(--cise-text)" }}>{title}</Typography>
      {subtitle && <Typography sx={{ color: "var(--cise-text-muted)", fontSize: 13, mt: 0.3 }}>{subtitle}</Typography>}
      <Box sx={{ mt: 2 }}>{children}</Box>
    </Paper>
  );
}

export default function SecurityTab() {
  const [cfg, setCfg] = useState({
    auditLogs: true,
    exportCsvEnabled: true,
    retentionDays: 180,
    allowDelete: false,
  });

  return (
    <Grid container spacing={2}>
      <Grid item xs={12} md={7}>
        <Card title="Segurança & Dados" subtitle="LGPD, auditoria, exportação e retenção">
          <Stack spacing={2}>
            <FormControlLabel
              control={<Switch checked={cfg.auditLogs} onChange={(e) => setCfg((p) => ({ ...p, auditLogs: e.target.checked }))} />}
              label="Ativar logs de auditoria (mudanças em lead/etapas)"
            />

            <FormControlLabel
              control={<Switch checked={cfg.exportCsvEnabled} onChange={(e) => setCfg((p) => ({ ...p, exportCsvEnabled: e.target.checked }))} />}
              label="Permitir exportação CSV (relatórios/leads)"
            />

            <FormControlLabel
              control={<Switch checked={cfg.allowDelete} onChange={(e) => setCfg((p) => ({ ...p, allowDelete: e.target.checked }))} />}
              label="Permitir exclusão definitiva (alto risco)"
            />

            <Divider />

            <Typography sx={{ fontWeight: 900 }}>Retenção</Typography>
            <Typography sx={{ color: "var(--cise-text-muted)", fontSize: 13 }}>
              Defina por quanto tempo manter conversas e histórico.
            </Typography>

            <Chip
              label={`Retenção atual: ${cfg.retentionDays} dias (mock)`}
              sx={{ fontWeight: 900, border: "1px solid var(--border)", bgcolor: "var(--bg)", width: "fit-content" }}
            />

            <Stack direction="row" justifyContent="flex-end" sx={{ mt: 1 }}>
              <Button
                variant="contained"
                sx={{ textTransform: "none", fontWeight: 900, bgcolor: "var(--cise-blue)", "&:hover": { bgcolor: "var(--cise-blue)" } }}
                onClick={() => alert("Salvar segurança (futuro)")}
              >
                Salvar
              </Button>
            </Stack>
          </Stack>
        </Card>
      </Grid>

      <Grid item xs={12} md={5}>
        <Card title="Backup / Exportação" subtitle="Ações administrativas (mock)">
          <Stack spacing={1}>
            <Button
              variant="outlined"
              sx={{ textTransform: "none", fontWeight: 900, borderColor: "var(--border)" }}
              onClick={() => alert("Exportar leads CSV (futuro)")}
            >
              Exportar Leads (CSV)
            </Button>

            <Button
              variant="outlined"
              sx={{ textTransform: "none", fontWeight: 900, borderColor: "var(--border)" }}
              onClick={() => alert("Exportar conversas (futuro)")}
            >
              Exportar Conversas
            </Button>

            <Button
              variant="outlined"
              sx={{ textTransform: "none", fontWeight: 900, borderColor: "var(--border)" }}
              onClick={() => alert("Gerar backup (futuro)")}
            >
              Gerar Backup
            </Button>
          </Stack>

          <Typography sx={{ color: "var(--cise-text-muted)", fontSize: 13, mt: 2 }}>
            Depois a gente liga isso em Cloud Functions (gerar CSV/backup e salvar no Storage).
          </Typography>
        </Card>
      </Grid>
    </Grid>
  );
}